import React from 'react'
import USDefaultTemplate from 'src/components/template/us'
import styled from 'styled-components'

export default (props) => {
  return (
    <StyledWrapper>
      <USDefaultTemplate
        location={props.location}
        lang="en"
        market="us"
        offerBanner={{
          title: [
            'Special offer unlocked!',
            'Xbox Game Pass gets you an extended 14-day FREE trial.',
          ],
        }}
        title="Watch live sports, shows, movies & news"
        subtitle="Stream it all live anytime, anywhere, from any device."
        hasOfferInput={true}
        logo="https://assets-imgx.fubo.tv/marketing/lp/images/partners/logo-lockup-xbox.png?ch=width&auto=format,compress"
      />
    </StyledWrapper>
  )
}

const StyledWrapper = styled.div``
